import ResetPassword from './containers/ResetPassword';
import { IndexRoute } from 'react-router';
import React from 'react';

export {uiDataResetPassword} from './reducers/ResetPassword';
export default ResetPassword;